export const CUSTOM_FIELD_TARGET = {
  LOAN: 'Loan',
  SUBJECT_PROPERTY: 'SubjectProperty',
  BORROWER: 'Borrower',
  PROPERTY: 'Property',
  INCOME: 'Income',
  ASSET: 'Asset',
  LIABILITY: 'Liability',
  NON_BORROWER_ENTITY: 'NonBorrowerEntity',
};

export const CUSTOM_FIELD_TARGET_LABEL = {
  [CUSTOM_FIELD_TARGET.LOAN]: 'Loan',
  [CUSTOM_FIELD_TARGET.SUBJECT_PROPERTY]: 'Subject Property',
  [CUSTOM_FIELD_TARGET.BORROWER]: 'Borrower',
  [CUSTOM_FIELD_TARGET.PROPERTY]: 'Property',
  [CUSTOM_FIELD_TARGET.INCOME]: 'Income',
  [CUSTOM_FIELD_TARGET.ASSET]: 'Asset',
  [CUSTOM_FIELD_TARGET.LIABILITY]: 'Liability',
  [CUSTOM_FIELD_TARGET.NON_BORROWER_ENTITY]: 'Non-Borrower Entity',
};

export const CUSTOM_FIELD_TARGET_GROUP_LABEL = {
  [CUSTOM_FIELD_TARGET.LOAN]: 'Loan',
  [CUSTOM_FIELD_TARGET.SUBJECT_PROPERTY]: 'Subject Property',
  [CUSTOM_FIELD_TARGET.BORROWER]: 'Borrowers',
  [CUSTOM_FIELD_TARGET.PROPERTY]: 'Properties',
  [CUSTOM_FIELD_TARGET.INCOME]: 'Incomes',
  [CUSTOM_FIELD_TARGET.ASSET]: 'Assets',
  [CUSTOM_FIELD_TARGET.LIABILITY]: 'Liabilities',
  [CUSTOM_FIELD_TARGET.NON_BORROWER_ENTITY]: 'Non-Borrower Entities',
};

export const CUSTOM_FIELD_TARGET_ORDER = [
  CUSTOM_FIELD_TARGET.LOAN,
  CUSTOM_FIELD_TARGET.SUBJECT_PROPERTY,
  CUSTOM_FIELD_TARGET.BORROWER,
  CUSTOM_FIELD_TARGET.PROPERTY,
  CUSTOM_FIELD_TARGET.INCOME,
  CUSTOM_FIELD_TARGET.ASSET,
  CUSTOM_FIELD_TARGET.LIABILITY,
  CUSTOM_FIELD_TARGET.NON_BORROWER_ENTITY,
];

export const UNKNOWN_CUSTOM_FIELD_TARGET_LABEL = 'Other';
